/**
 * @file DU表单
 * @author sunwen05
 * @modify zhangzhe
 */

import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {Form, Tooltip} from 'acud';
import {OutlinedQuestionCircle} from 'acud-icon';

import {CLS_PREFIX} from '..';
import duFormComponents from './DuFormComponents';
import {defaultOptions} from '../constants';
import {getValuePropName} from '../formUtil';

import type {DuFormItemProps} from '../index';

const FormItem = Form.Item;

const DuFormItem: React.FunctionComponent<DuFormItemProps> = props => {
    const {prefixCls = CLS_PREFIX, field = {}, control, option, noLabel} = props;
    const formItemOptions = {...defaultOptions, ...option}; // formItem配置
    const {layouts} = formItemOptions;

    // 基本配置
    const {type, name, label, rules, infoIcon, content, formConfig} = control;
    let {extra} = control;
    // 栅格
    const {formItemLabelLayout, formItemEmptyLabelLayout, formItemNoneLayout} = layouts;

    if (infoIcon) {
        const {className, tooltipProps} = infoIcon;
        extra = (
            <>
                <span className={`${className ? className : 'acud-form-extra-inline'}`}>
                    <Tooltip
                        {...tooltipProps}
                    >
                        <OutlinedQuestionCircle width={16} />
                    </Tooltip>
                </span>
                {extra}
            </>
        );
    }

    // FormItem配置项
    const formItemLayout = noLabel ? formItemNoneLayout : label ? formItemLabelLayout : formItemEmptyLabelLayout;

    const formItemPrefixCls = `${prefixCls}-item`;
    let formItemCls = `${formItemPrefixCls} ${formItemPrefixCls}-${name} ${formItemPrefixCls}-type-${type}`;
    // 如果设置了acudpro ConfigProvider, prefixCls会变成acud-pro-form
    // 适配老的`du-form-item-${name}`
    if (prefixCls !== CLS_PREFIX) {
        formItemCls = formItemCls + ` du-form-item-${name}`;
    }

    const formItemConfig = type === 'text' ? {
        className: formItemCls,
        label,
        extra,
        valuePropName: getValuePropName(control),
        ...formItemLayout
    } : {
        className: formItemCls,
        label,
        extra,
        rules,
        name,
        valuePropName: getValuePropName(control),
        shouldUpdate: _.isEmpty(formConfig && formConfig.dependencies),
        ...formConfig,
        ...formItemLayout,
        ...field
    };
    const duFormComponentsProps = _.omit(props, 'prefixCls') as DuFormItemProps;
    const DuFormBlockTpl = duFormComponents(duFormComponentsProps);

    return type ? (
        <FormItem {...formItemConfig}>
            {DuFormBlockTpl}
        </FormItem>
    ) : content;
};

DuFormItem.propTypes = {
    control: PropTypes.object.isRequired,
    option: PropTypes.object.isRequired
};

export default DuFormItem;
